import React, { useState } from "react";

import { CopyRegular, OpenRegular } from "@fluentui/react-icons";
import {
  Body2,
  Button,
  Caption1,
  Card,
  CardProps,
  mergeClasses,
  Tooltip,
  useRestoreFocusTarget,
} from "@fluentui/react-components";

import { Stack } from "../stack";
import { YellowPadLogo } from "../yellowpad-logo";
import { DuplicatePlaybookDialog } from "../duplicate-playbook-dialog";
import { useYellowpadPlaybookCardStyles } from "./styles";

import { Playbook } from "@/types/risk-analysis";

export interface YellowpadPlaybookCardProps extends CardProps {
  playbook: Playbook;
  onOpen: () => void;
}

export function YellowpadPlaybookCard({ playbook, className, onOpen, ...props }: YellowpadPlaybookCardProps) {
  const styles = useYellowpadPlaybookCardStyles();

  const restoreDuplicateTargetAttribute = useRestoreFocusTarget();
  const [duplicateDialogOpen, setDuplicateDialogOpen] = useState<boolean>(false);

  return (
    <Card className={mergeClasses(styles.card, className)} {...props}>
      <Stack align="center" justify="between">
        <div>
          <Stack align="center" gap="0.25rem">
            <YellowPadLogo />
            <Body2 className={styles.name}>{playbook.name}</Body2>
          </Stack>
          <Caption1 className={styles.updatedAt}>
            Last updated on {new Date(playbook.updatedAt).toLocaleDateString()}
          </Caption1>
        </div>
        <Stack align="center" gap="0.5rem">
          <Tooltip relationship="label" content="Open playbook">
            <Button appearance="primary" icon={<OpenRegular />} aria-label="Open playbook" onClick={onOpen} />
          </Tooltip>
          <Tooltip relationship="label" content="Duplicate playbook">
            <Button
              appearance="primary"
              icon={<CopyRegular />}
              aria-label="Duplicate playbook"
              onClick={() => setDuplicateDialogOpen(true)}
              {...restoreDuplicateTargetAttribute}
            />
          </Tooltip>
        </Stack>
      </Stack>
      <DuplicatePlaybookDialog
        playbook={playbook}
        open={duplicateDialogOpen}
        onOpenChange={(_, data) => setDuplicateDialogOpen(data.open)}
      />
    </Card>
  );
}
